var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgClipBoardSchoolList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 73,
    viewBox: "0 0 62 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 71.7c0 .72-.58 1.3-1.3 1.3h-7.6c1.42 0 2.63-1.15 2.7-2.56v-.04h4.9c.72 0 1.3.58 1.3 1.3z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.85 4.5l-3.46 65.94c-.07 1.41-1.28 2.56-2.7 2.56H4.73c-1.42 0-2.51-1.15-2.44-2.56L5.75 4.5c.07-1.42 1.28-2.57 2.7-2.57h47.97c1.42 0 2.51 1.15 2.43 2.57z",
    fill: "#037F76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.76 6.23l-3.37 64.21c-.07 1.41-1.28 2.56-2.7 2.56h-2.86l2.76-27.61 3.94-39.37 2.24.21h-.01z",
    fill: "#005E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.96 40.72L55.4 70.44c-.07 1.41-1.28 2.56-2.7 2.56h-2.86l2.76-27.61c1.16-2.83 2-4.77 2.12-4.67h2.25-.01z",
    fill: "#002E30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 4.5l-3.46 65.94c-.07 1.41-1.28 2.56-2.69 2.56H2.58C1.16 73 .07 71.85.14 70.44L3.6 4.5c.07-1.42 1.28-2.57 2.7-2.57h47.88c1.41 0 2.5 1.15 2.42 2.57h.01z",
    fill: "#32A592"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.84 1.93C5.58 6.24 3.04 15.36 3.04 15.36L3.61 4.5c.07-1.42 1.28-2.57 2.7-2.57h14.53z",
    fill: "#46D3AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.52 6.13l-3.37 64.31c-.07 1.41-1.28 2.56-2.69 2.56H5.3c.53-1.51 1.1-3.32 1.54-4.55l37.19-17.24 3.05-1.41.29-1.57 5.66-30.79 3.48-11.31h.01z",
    fill: "#037F76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.71 40.72l-1.56 29.72c-.07 1.41-1.28 2.56-2.69 2.56H23.44s1.72-4.22 1.67-4.55c.01-.26 11.09-10.23 18.92-17.24 1.21-1.08 2.34-2.1 3.34-2.98l4.25-3.8s.47-.5 3.09-3.7v-.01z",
    fill: "#005E5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.42 10.16l-2.94 56.09c-.06 1.22-1.1 2.2-2.31 2.2H6.71c-1.21 0-2.88-1.09-2.81-2.31l2.89-55.2c.06-1.22 1.62-3.72 2.84-3.72h41.44c1.22 0 2.41 1.72 2.34 2.94h.01z",
    fill: "#9EE1EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.04 17.44l-2.56 48.81c-.06 1.22-1.1 2.2-2.31 2.2H6.84c.14-.38.28-.74.28-.74s44.9-49.79 45.16-49.91c.34-.16.75-.36.75-.36h.01z",
    fill: "#70B6DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.62 44.42l-1.14 21.82c-.06 1.22-1.1 2.2-2.31 2.2H25.11l-.13-.74 18.25-3.67 3.76-4.39 3.9-15.23h.74l-.01.01z",
    fill: "#3C79B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.72 9.41l-2.94 56.1c-.06 1.22-1.1 2.2-2.31 2.2H6.01a2.06 2.06 0 01-2.08-2.2l2.94-56.1c.06-1.21 1.1-2.2 2.31-2.2h41.46c1.21 0 2.15.99 2.08 2.2z",
    fill: "#E4F4F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.53 1H19.95c-.72 0-1.37.37-1.76.93-.21.28-.35.62-.38.98-.01.05-.02.1-.02.15l-.21 3.95c-.06 1.14.82 2.06 1.95 2.06h2.52l-.02.35c-.05 1.03.56 1.83 1.39 1.83H37c.83 0 1.52-.81 1.58-1.83l.02-.35h2.52c1.13 0 2.1-.92 2.16-2.06l.21-3.95C43.55 1.93 42.67 1 41.54 1h-.01zm.73 6.01c-.03.58-.53 1.05-1.1 1.05h-3.53l-.07 1.36c-.02.47-.3.83-.52.83H23.46c-.22 0-.46-.35-.43-.83l.07-1.36h-3.53a.983.983 0 01-.99-1.05l.21-3.95c.01-.21.08-.4.2-.56.2-.29.54-.48.9-.48h21.58c.57 0 1.02.47.99 1.05l-.21 3.95.01-.01z",
    fill: "#164C9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.839 1.93c-.09.03-.18.05-.28.08h-.67c-.36 0-.71.19-.9.48-.41.13-.81.27-1.19.41.04-.35.18-.7.38-.98h2.65l.01.01z",
    fill: "#3C79B0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.08 1H19.5c-1.08 0-2.01.84-2.14 1.89-.01.05-.02.11-.02.16L17.13 7c-.06 1.14.82 2.06 1.95 2.06h2.52l-.02.35c-.05 1.03.56 1.83 1.39 1.83h13.58c.83 0 1.52-.81 1.58-1.83l.02-.35h2.52c1.13 0 2.1-.92 2.16-2.06l.21-3.95c.06-1.13-.82-2.06-1.95-2.06l-.01.01zm.73 6.01c-.03.58-.53 1.05-1.1 1.05h-3.53l-.07 1.36c-.02.47-.3.83-.52.83H23.01c-.22 0-.46-.35-.43-.83l.07-1.36h-3.53a.983.983 0 01-.99-1.05l.21-3.95c.01-.23.1-.44.24-.61.2-.26.52-.43.86-.43h21.58c.57 0 1.02.47.99 1.05l-.21 3.95.01-.01z",
    fill: "#70B6DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.28 17.8l-2.5 47.71c-.06 1.22-1.1 2.2-2.31 2.2H7.12s30.33-8.74 34.7-18.64C46.2 39.16 52.28 17.8 52.28 17.8z",
    fill: "#BADEE2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.89 44.42l-1.11 21.09c-.06 1.22-1.1 2.2-2.31 2.2H24.98S40.11 62 43.66 59.43c3.55-2.58 7.23-15 7.23-15v-.01z",
    fill: "#80B8BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.76 1c-1.37.3-2.64.63-3.83 1.01h-.48c-.34 0-.66.17-.86.43-.42.14-.83.29-1.23.45C17.5 1.83 18.43 1 19.5 1h4.26z",
    fill: "#9EE1EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.94 37.82l-.02.4-.09 1.83c-.02.34-.31.62-.66.62H27.02a.58.58 0 01-.59-.62l.12-2.24c.02-.34.31-.62.66-.62h18.15c.34 0 .6.28.58.62v.01z",
    fill: "#458CFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 45.24H11.6c-.6 0-1.15-.24-1.56-.67-.41-.43-.62-1-.58-1.6l.43-8.18a2.274 2.274 0 012.27-2.16h8.18c.6 0 1.16.24 1.56.67.4.43.61 1 .58 1.6l-.43 8.18c-.06 1.19-1.08 2.16-2.27 2.16zm-7.62-10.58c-.13 0-.25.12-.26.25l-.43 8.18s0 .08.03.1c.02.02.06.04.1.04h8.18c.13 0 .25-.12.26-.25l.43-8.18s0-.08-.03-.1c-.03-.02-.06-.04-.1-.04h-8.18z",
    fill: "#32A592"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 42.83h-.09a.992.992 0 01-.69-.37l-2.82-3.43c-.35-.43-.29-1.06.14-1.42.43-.35 1.07-.29 1.42.14l2.16 2.64 5.92-5.09c.42-.36 1.06-.32 1.42.11.36.43.32 1.06-.11 1.42l-6.7 5.76c-.18.16-.42.24-.66.24h.01z",
    fill: "#002E30"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.01 55.48l-.11 2.24c-.02.34-.31.62-.66.62H26.09c-.34 0-.6-.28-.59-.62l.12-2.24c.02-.34.31-.62.66-.62h18.15c.34 0 .6.28.58.62z",
    fill: "#458CFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.86 62.89h-8.18c-.6 0-1.16-.24-1.56-.67-.4-.43-.61-1-.58-1.6l.43-8.18c.06-1.19 1.08-2.16 2.27-2.16h8.18a2.136 2.136 0 012.14 2.27l-.43 8.18a2.274 2.274 0 01-2.27 2.16zm-7.62-10.58c-.13 0-.25.12-.26.25l-.43 8.18s0 .08.03.1c.03.02.06.04.1.04h8.18c.13 0 .25-.12.26-.25l.43-8.18s0-.08-.03-.1c-.03-.02-.06-.04-.1-.04h-8.18z",
    fill: "#32A592"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.19 60.48h-.09a.992.992 0 01-.69-.37l-2.82-3.43c-.35-.43-.29-1.06.14-1.42.43-.35 1.07-.29 1.42.14l2.16 2.64 5.92-5.09c.42-.36 1.06-.32 1.42.11.36.42.32 1.06-.11 1.42l-6.7 5.76c-.18.16-.42.24-.66.24h.01z",
    fill: "#002E30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.01 55.48l-.11 2.24c-.02.34-.31.62-.66.62H30.81c2.06-1.11 3.98-2.27 5.65-3.49h7.95c.34 0 .6.28.58.62l.02.01zM45.92 38.22l-.09 1.83c-.02.34-.31.62-.66.62h-.11c.29-.81.57-1.63.86-2.46v.01z",
    fill: "#2560E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.7 17.28c-.15 0-.27-.12-.27-.27v-3.4c0-.15.12-.27.27-.27.15 0 .27.12.27.27v3.4c0 .15-.12.27-.27.27z",
    fill: "#540C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 14.84c-.35.04-.84-.13-1.29-.39-.41-.24-1.11-.06-1.31-.02v-.82s.84-.27 1.31 0c.45.27 1.13.35 1.2.33l.03.03c.05.09.06.48.05.86l.01.01z",
    fill: "#CE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.299 14.84v.4c-.01.29-.02.51-.02.51-.08.13-.43.01-.69-.09-.13-.04-.26-.11-.39-.17-.06-.03-.12-.06-.18-.1a.247.247 0 00-.09-.04.783.783 0 00-.34-.07c-.19-.02-.41 0-.57.03-.1.01-.18.03-.25.05-.02 0-.03.01-.05.01h-.01v-.94c.19-.04.9-.22 1.31.02.44.26.94.43 1.29.39h-.01z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28 15.75c-.08.13-.43.01-.69-.09.26.1.5.14.69.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68 22.1l-2.42-4.3a.687.687 0 00-.6-.36H30.39c-.38 0-.69.32-.69.69 0-.38-.31-.69-.69-.69H16.75c-.25 0-.48.14-.6.36l-2.42 4.3c-.27.46.07 1.03.6 1.03h14.68c.39 0 .69-.31.69-.69 0 .39.32.69.69.69h14.68c.53 0 .87-.57.61-1.03z",
    fill: "#CE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.11 23.13h-3.16l-5.26-4.95-5.25 4.95h-3.16s.02-.03.03-.03l6.01-5.66h1.67c.39 0 .69.32.69.69 0-.38.32-.69.69-.69h1.68l6 5.66.03.03h.03z",
    fill: "#540C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.18 23.13v6.67h-8.81c-.49 0-.88-.39-.88-.88v-5.79h9.7-.01z",
    fill: "#E8BB79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.18 23.13h-9.7v1.14h9.7v-1.14z",
    fill: "#D38E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92 23.13v5.79c0 .49-.39.88-.88.88h-8.81v-6.67h9.7-.01z",
    fill: "#E8BB79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93 23.13h-9.7v1.14h9.7v-1.14z",
    fill: "#D38E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.23 21.7v8.1h-9.05v-8.1l4.52-4.27 4.53 4.27z",
    fill: "#F4DCA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.23 22.08v1.62l-4.53-4.27-4.52 4.26v-1.61l4.52-4.27 4.53 4.27z",
    fill: "#E8BB79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.74 23.99c-.21 0-.42-.08-.59-.23l-5.45-5.14-5.45 5.14c-.34.33-.89.31-1.21-.04a.846.846 0 01.04-1.21l6.04-5.69c.33-.31.85-.31 1.18 0l6.04 5.69c.34.32.36.87.04 1.21-.17.18-.4.27-.62.27h-.02z",
    fill: "#EF1616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.51 24.27s.03 5.53-1.82 5.53h2.49v-5.53h-.67zM43.92 24.27v4.65c0 .49-.39.88-.88.88h-1.6c1.85 0 1.82-5.53 1.82-5.53h.67-.01z",
    fill: "#D38E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.289 25.51h-6.03a.37.37 0 00-.37.37v1.17c0 .204.165.37.37.37h6.03a.37.37 0 00.37-.37v-1.17a.37.37 0 00-.37-.37zM42.09 25.51h-6.03a.37.37 0 00-.37.37v1.17c0 .204.165.37.37.37h6.03a.37.37 0 00.37-.37v-1.17a.37.37 0 00-.37-.37zM29.699 24.01a1.57 1.57 0 100-3.14 1.57 1.57 0 000 3.14z",
    fill: "#70B6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.86 26.46h2.1c.23 0 .42.19.42.42v2.92h-2.93v-2.92c0-.23.19-.42.42-.42h-.01z",
    fill: "#7C3B00"
  }))));
}

export default SvgImgClipBoardSchoolList;